import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

export default function ScrollToTop() {
    const { pathname } = useLocation();
    const navigationType = useNavigationType();
    useEffect(() => {
        if (navigationType === "POP") return;

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                window.scrollTo(0, 0);
            });
        });
    }, [pathname]);

    return null;
}